import { EntityKind } from 'mdello-client-ts/dist/src/interfaces/admin/entity.interface';
import { useMutation, useQueryClient } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { getClient } from 'src/util/mdello-instance';
import { BoxMetadata, BoxResponseData } from './interfaces/box.interface';

/**
 * Stamps `metadata.readAt` on a box so the list can tell read records from newly
 * submitted ones. The box schema has no dedicated field, and the entity update
 * endpoint overwrites `metadata` wholesale, so the existing metadata is merged here.
 */
const markBoxRead = async (box: BoxResponseData): Promise<void> => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const metadata: BoxMetadata = {
    ...(box.metadata || {}),
    readAt: new Date().toISOString()
  };

  await getClient()?.updateEntity(
    {
      kind: EntityKind.BOX,
      projectId: currentProject._id
    },
    box._id,
    { metadata }
  );
};

export const useMarkBoxRead = () => {
  const queryClient = useQueryClient();

  /** Deliberately silent on error: failing to flip the status must not interrupt
   *  reading the box — the record simply stays "Unread" until the next visit. */
  return useMutation((box: BoxResponseData) => markBoxRead(box), {
    onSuccess: (_result, box) => {
      queryClient.invalidateQueries([QueryKey.BOX]);
      queryClient.invalidateQueries([QueryKey.BOX_DETAILS, box._id]);
    }
  });
};
